$(document).ready(function () {
  const defaults = {
    cartItemMax: 3,
    cartItems: ".ajax-cart-item", //classname
    cartModal: ".js-ajax-cart-modal", // classname
    cartModalContent: ".js-ajax-cart-modal-content", // classname
    cartModalClose: ".js-ajax-cart-modal-close", // classname
    cartDrawer: ".js-ajax-cart-drawer", // classname
    cartDrawerHeader: ".js-ajax-cart-drawer-header", // classname
    cartDrawerContent: ".js-ajax-cart-drawer-content", // classname
    cartDrawerClose: ".js-ajax-cart-drawer-close", // classname
    cartDrawerTrigger: ".js-ajax-cart-drawer-trigger", // classname
    cartOverlay: ".js-ajax-cart-overlay", // classname
    cartCounter: ".js-ajax-cart-counter", // classname
    addToCart: ".js-ajax-add-to-cart", // classname
    removeFromCart: ".js-ajax-remove-from-cart", //classname
    removeFromCartNoDot: "js-ajax-remove-from-cart", //classname,
    checkoutButton: ".js-ajax-checkout-button",
    qtyAdjust: ".ajax-cart-qty__adjust",
    qtySelect: ".ajax-cart-qty__num.select",
    bottomButtons: ".ajax-cart-drawer__buttons",
    cartSubtotalValue: ".cart-subtotal-value",
    cartShippingValue: ".cart-shipping-value",
  };
  const cartModal = document.querySelector(defaults.cartModal);
  const cartModalContent = document.querySelector(defaults.cartModalContent);
  const cartModalClose = document.querySelector(defaults.cartModalClose);
  const cartDrawer = document.querySelector(defaults.cartDrawer);
  const cartDrawerHeader = $(defaults.cartDrawerHeader);
  const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
  const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
  const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
  const cartOverlay = document.querySelector(defaults.cartOverlay);
  const cartCounter = document.querySelector(defaults.cartCounter);
  const addToCart = document.querySelectorAll(defaults.addToCart);
  const bottomButtons = document.querySelector(defaults.bottomButtons);
  const cartSubTotal = document.querySelector(defaults.cartSubtotalValue);
  const cartShippingValue = document.querySelector(
    defaults.cartShippingValue
  );

  let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
  let qtyAdjust = $(defaults.qtyAdjust);
  const checkoutButton = document.querySelector(defaults.checkoutButton);
  const htmlSelector = document.documentElement;

  function setCheckoutButtonValidity(valid) {
    //console.log("setCheckoutButtonValidity");
    const checkoutBtn = document.querySelector(
      "form.cart button.checkout_button"
    );
    if (valid) {
      checkoutBtn.classList.remove("disabled");
    } else {
      checkoutBtn.classList.add("disabled");
    }
  }

  function areCartQtysValid(qtys) {
    //console.log("handleCheckoutButtonValidity");
    const largestQty = Math.max(...qtys);
    const max = defaults.cartItemMax;
    setCheckoutButtonValidity(largestQty <= max);
  }

  // validates cart for max item qty
  function validateCartQtys() {
    //console.log('validateCartQtys');
    const cartItems = document.querySelectorAll(defaults.cartItems);
    if (cartItems.length > 0) {
      const qtys = [];
      cartItems.forEach(function (item) {
        let itemQty = item.querySelector(".ajax-cart-qty__num").value;
        qtys.push(parseInt(itemQty));
      });
      areCartQtysValid(qtys);
    }
  }

  function isMensEligibleCart() {
    const mensWords = [" Men", "Men ", "Men’s ", "Men's "];
    const cartItems = document.querySelectorAll(".ajax-cart-item__title");
    if (cartItems.length > 0) {
      let isMens = false;
      for (var i = 0; i < cartItems.length; i++) {
        const title = cartItems[i].textContent;
        if (mensWords.some((word) => title.includes(word))) {
          return true;
        }
      }
      return false;
    }
  }

  function hideIneligibleUpsells() {
    const isMens = isMensEligibleCart();
    var products = $(".cart-swiper .swiper-slide.men-only");
    if (!isMens) {
      products.hide();
    } else {
      products.show();
    }
  }

  // addToCart link handler
  for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener("click", function (event) {
      event.preventDefault();
      $(event.target).closest("form").trigger("submit");
    });
  }

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function setCartAttributes() {
    var drOffice = getCookie("pro_doctor");
    var segmentID = getCookie("segment_anonymous_id");

    var cartAttrs = {
      attributes: {
        "doctors-office": drOffice,
        "segment-clientID": segmentID,
      },
    };

    $.post("/cart/update.js", cartAttrs);
  }

  // cart form handler
  $("[data-product-form]").submit(function (e) {
    e.preventDefault();
    const $form = $(this);
    let data = $form.serialize();

    const dataArray = $form.serializeArray();

    const isGA = dataArray.find((el) => el.value === "growth-activator");
    const idObj = dataArray.find((el) => el.name === "id");
    const idObjSub = dataArray.find((el) => el.name === "id-subscription");
    const productIdObj = dataArray.find((el) => el.name === "product-id");
    const productIdObjSub = dataArray.find(
      (el) => el.name === "product-id-subscription"
    );
    const ptObj = dataArray.find((el) => el.name === "purchase_type");
    const spObj = dataArray.find((el) => el.name === "selling_plan");

    //remove selling_plan for one time purchase
    if (ptObj?.value === "onetime" && spObj?.value) {
      data = data.replaceAll(spObj?.value, "");
    } else if (
      ptObj?.value === "autodeliver" &&
      idObjSub?.value &&
      productIdObjSub?.value
    ) {
      //swap selling_plan for one subscription
      data = data.replaceAll(idObj?.value, idObjSub?.value);
      data = data.replaceAll(productIdObj?.value, productIdObjSub?.value);
    }

    //workaround for avoiding GA dupes in cart
    if (isGA && idObj) {
      data = `id=${idObj.value}&purchase_type=onetime`;
    }

    // console.log("ajax cart", data);
    // debugger;
    $.post({
      url: "/cart/add.js",
      data: data,
      dataType: "json",
    }).done(function (item) {
      $(".js-ajax-cart-drawer-trigger")[0].click();
      $form.closest(".modal").find(".close-modal").click();
      setCartAttributes();
    });
  });

  function updateShippingRate() {
    if (!cartShippingValue) return;

    // The shipping_rates endpoint requires a destination to calculate real
    // rates. Use the logged-in customer's saved address when available,
    // otherwise fall back to a representative US address as an estimate
    // (this store's shipping profiles are US-based).
    const savedAddress = (window.theme && theme.customerDefaultAddress) || null;
    const estimateAddress = {
      country: (savedAddress && savedAddress.country) || "United States",
      province: (savedAddress && savedAddress.province) || "New York",
      zip: (savedAddress && savedAddress.zip) || "10001",
    };

    $.ajax({
      type: "GET",
      url: "/cart/shipping_rates.json",
      data: {
        "shipping_address[country]": estimateAddress.country,
        "shipping_address[province]": estimateAddress.province,
        "shipping_address[zip]": estimateAddress.zip,
      },
      dataType: "json",
      success: function (response) {
        const rates = (response && response.shipping_rates) || [];
        if (!rates.length) return;
        const cheapest = rates.reduce(function (min, rate) {
          return parseFloat(rate.price) < parseFloat(min.price) ? rate : min;
        }, rates[0]);
        const priceCents = Math.round(parseFloat(cheapest.price) * 100);

        //Force standard decimal format instead of using the global theme.moneyFormat
        const decimalFormat = theme.moneyFormat.replace('amount_no_decimals', 'amount').replace('amount_no_decimals_with_comma_separator', 'amount_with_comma_separator');

        cartShippingValue.innerHTML = priceCents === 0 ? "Free" : theme.Currency.formatMoney(priceCents, decimalFormat);

      },
      error: function () {
        // Leave the existing text in place if rates can't be calculated
        // (e.g. an empty cart or no shipping profile match yet).
      },
    });
  }

  function fetchCart(scroll) {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        onCartUpdate(cart);
        if (cart.item_count === 0) {
          cartDrawerContent.parentElement.classList.add("empty");
          cartDrawerContent.innerHTML =
            '<div class = "empty-message">Cart is empty</div> <button id="shopProducts" onclick="scrollToProductsBlock(event)" class="button green-btn"><span>Shop products</span></button>';
          bottomButtons.classList.add("is-hidden");
        } else {
          cartDrawerContent.parentElement.classList.remove("empty");
          renderCart(cart, scroll);
          bottomButtons.classList.remove("is-hidden");
        }
      },
    });
  }

  function changeItem(line, quantity, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: `quantity=${quantity}&line=${line}`,
      dataType: "json",
      success: function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          onCartUpdate(cart);
          fetchCart();
        }
      },
    });
  }

  function onCartUpdate(cart) {
    //console.log("onCartUpdate")
    cartCounter.innerHTML = cart.item_count;
    if (cart.item_count === 0) {
      cartCounter.parentElement.classList.add("hide");
    } else {
      cartCounter.parentElement.classList.remove("hide");
    }
  }

  function addToCartOk(product) {
    //console.log("addToCartOK")
    cartModalContent.innerHTML = `${product.title} was added to the cart!`;
    cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    openAddModal();
    openCartOverlay();
    fetchCart();
  }

  function removeProductFromCart() {
    cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
  }

  function addToCartFail() {
    cartModalContent.innerHTML =
      "The product you are trying to add is out of stock.";
    openAddModal();
    openCartOverlay();
  }

  function renderCart(cart, scroll) {
    //console.log("renderCart");
    // console.log(cart.items);
    clearCartDrawer();
    cart.items.forEach(function (item, index) {
      if (item.image) {
        item.image = item.image
          .replace(/(\.[^.]*)$/, "_medium$1")
          .replace("http:", "");
      }

      let icon = "";
      let packaging = "";
      let old_price = "";
      let shipping_frequency_text = "";
      let is_subscription_attr = "";
      //items[1].selling_plan_allocation.selling_plan.name
      if (item.properties != null) {
        if (item.properties.shipping_interval_frequency) {
          shipping_frequency_text = ", BILLED QUARTERLY";
          icon = `<img class="icon" src="${refreshIcon}"/>`;
          is_subscription_attr = "data-subscription";
          packaging = `${item.properties.shipping_interval_frequency}-month supply`;
        }
        if (item.properties.packaging) {
          packaging = `${item.properties.packaging}-month supply`;
        }
        if (
          item.properties.cart_original_price &&
          parseInt(item.original_price) !==
            parseInt(item.properties.cart_original_price)
        ) {
          old_price =
            `<span class = "old-price">` +
            theme.Currency.formatMoney(
              item.properties.cart_original_price * item.quantity,
              theme.moneyFormat
            ) +
            `</span>`;
        }
      }
      if (item?.selling_plan_allocation?.selling_plan.name) {
        icon = `<img class="icon" src="${refreshIcon}"/>`;
        // Round any decimal discount percentage (e.g. "10.23%" -> "10%")
        shipping_frequency_text = item.selling_plan_allocation.selling_plan.name.replace(
          /(\d+(\.\d+)?)%/,
          function (match, num) {
            return Math.round(parseFloat(num)) + "%";
          }
        );
      }
      const currentPrice =
        `<span class = "current-price">` +
        theme.Currency.formatMoney(item.line_price, theme.moneyFormat) +
        `</span>`;
      const productTitle = `<div class="ajax-cart-item__title">${item.title}</div>`;
      const productPlan = `<div class="ajax-cart-item__plan">${icon}${packaging}${shipping_frequency_text}</div>`;
      const productImage = `<img class="ajax-cart-item__image  ${item.title}" src="${item.image}" alt="" />`;
      const productPrice = `<div class="ajax-cart-item__price desktop-only">${
        currentPrice + old_price
      }</div>`;
      const isMaxQty = item.quantity > 3;
      if (isMaxQty) {
        var list = [];
        for (var i = 4; i <= item.quantity; i++) {
          list.push(i);
        }
        //console.log(list)
        var additionalOptions = list.map(function (itm) {
          // console.log(itm)
          // console.log(item.quantity)
          if (itm === item.quantity) {
            return `<option value="${itm}" selected="true" disabled="true">${itm}</option>`;
          }
          return `<option value="${itm}" disabled="true">${itm}</option>`;
        });
      }
      // const disabledOption = item.quantity > 3 ? `<option disabled value="${item.quantity}">${item.quantity}</option>` : ``;
      // debug properties
      //const productQuantity = `item.properties ${JSON.stringify(item.properties)}<div class="ajax-cart-item__quantity">` +
      const productQuantity =
        `<div class="ajax-cart-item__quantity">` +
        `<div class="ajax-cart-qty ${isMaxQty ? "disabled" : ""}">` +
        // `<button class="ajax-cart-qty__adjust ajax-cart-qty__adjust--minus">-</button>` +
        // `<input type="number" class="ajax-cart-qty__num" min="1" max="3" pattern="[0-9]*" value="${item.quantity}">` +
        `<select class="ajax-cart-qty__num select" value="${item.quantity}">` +
        `<option value="1" ${
          item.quantity === 1 ? "selected" : ""
        }>1</option>` +
        `<option value="2" ${
          item.quantity === 2 ? "selected" : ""
        }>2</option>` +
        `<option value="3" ${
          item.quantity === 3 ? "selected" : ""
        }>3</option>` +
        additionalOptions +
        `</select>` +
        // `<button class="ajax-cart-qty__adjust ajax-cart-qty__adjust--plus ${item.quantity >= 3 ? 'disabled' : ''}">+</button>` +
        `</div>` +
        `<div class="ajax-cart-item__price mobile-only">${old_price}${currentPrice}</span>` +
        `</div>` +
        `</div>`;
      const productRemove = `<div class="ajax-cart-item__remove-container"><div class="ajax-cart-item__remove  ${defaults.removeFromCartNoDot}"></div></div>`;
      const productMiddle = `<div class="ajax-cart-item__middle">${productTitle}${productPlan}${productQuantity}</div>`;
      const productContent = `<div class="ajax-cart-item-content">${productImage}${productMiddle}${productPrice}</div>`;
      const concatProductInfo = `<div class="ajax-cart-item ajax-cart-item__single" ${is_subscription_attr} data-line="${Number(
        index + 1
      )}">${productRemove}${productContent}</div>`;
      cartDrawerContent.innerHTML =
        cartDrawerContent.innerHTML + concatProductInfo;
    });
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    for (let i = 0; i < removeFromCart.length; i++) {
      removeFromCart[i].addEventListener("click", function () {
        const line = this.parentNode.parentNode.getAttribute("data-line");
        changeItem(line, 0);
      });
    }

    qtySelect = $(defaults.qtySelect);

    // var selects = $(".ajax-cart-qty__num.select");
    // $(selects).on('change', function() {
    //   console.log("$(this) ", $(this))
    //   console.log("$(this).find(:selected).val(); ", $(this).find(":selected").val())
    // });

    $(qtySelect).on("change", function () {
      console.log("qtySelect ", qtySelect);
      var $el = $(this),
        line = $el.closest(".ajax-cart-item__single").data("line"),
        qty = parseInt($(this).find(":selected").val().replace(/\D/g, ""));

      qty = validateQty(qty);

      console.log("qty ", qty);

      // if (!$el.hasClass('disabled')) {
      // Add or subtract from the current quantity
      // if ($el.hasClass('ajax-cart-qty__adjust--plus')) {
      //   qty += 1;
      // } else {
      //   qty -= 1;
      //   if (qty <= 0) qty = 0;
      // }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        changeItem(line, qty);
      } else {
        $el.val(qty);
      }
      cartSubTotal.innerHTML = theme.Currency.formatMoney(
        cart.items_subtotal_price,
        theme.moneyFormat
      );

      // } else {
      //   if ($el.hasClass('ajax-cart-qty__adjust--plus')) {
      //     $el.parent(".ajax-cart-qty").addClass("show-msg");
      //   }
      // }
    });

    // qtyAdjust = $(defaults.qtyAdjust);
    // $(defaults.qtyAdjust).click(function() {
    //   var $el = $(this),
    //     line = $el.closest('.ajax-cart-item__single').data('line'),
    //     $qtySelector = $el.siblings('.ajax-cart-qty__num'),
    //     qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    //   qty = validateQty(qty);

    //   if (!$el.hasClass('disabled')) {
    //     // Add or subtract from the current quantity
    //     if ($el.hasClass('ajax-cart-qty__adjust--plus')) {
    //       qty += 1;
    //     } else {
    //       qty -= 1;
    //       if (qty <= 0) qty = 0;
    //     }

    //     // If it has a data-line, update the cart.
    //     // Otherwise, just update the input's number
    //     if (line) {
    //       changeItem(line, qty);
    //     } else {
    //       $qtySelector.val(qty);
    //     }
    //     cartSubTotal.innerHTML = theme.Currency.formatMoney(cart.items_subtotal_price, theme.moneyFormat);
    //   } else {
    //     if ($el.hasClass('ajax-cart-qty__adjust--plus')) {
    //       $el.parent(".ajax-cart-qty").addClass("show-msg");
    //     }
    //   }
    // });

    cartSubTotal.innerHTML = theme.Currency.formatMoney(
      cart.items_subtotal_price,
      theme.moneyFormat
    );

    if (scroll) {
      try {
        $(".ajax-cart-drawer__content-container").scrollTop(0);
      } catch (e) {}
    }

    validateCartQtys();
    hideIneligibleUpsells();
    updateShippingRate();
  }

  function openCartDrawer() {
    cartDrawer.classList.add("is-open");
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove("is-open");
  }

  function clearCartDrawer() {
    cartDrawerContent.innerHTML = "";
  }

  function openAddModal() {
    cartModal.classList.add("is-open");
  }

  function closeAddModal() {
    cartModal.classList.remove("is-open");
  }

  function openCartOverlay() {
    $("body").addClass("ajax-cart-drawer-open");
    cartOverlay.classList.add("is-open");
    htmlSelector.classList.add("is-locked");
  }

  function closeCartOverlay() {
    $("body").removeClass("ajax-cart-drawer-open");
    cartOverlay.classList.remove("is-open");
    htmlSelector.classList.remove("is-locked");
  }

  function adjustCartHeaderHeight() {
    const h = $("header").outerHeight();
    cartDrawerHeader.css("min-height", h);
  }

  function validateQty(qty) {
    console.log(qty);
    if (parseFloat(qty) !== parseInt(qty) || isNaN(qty)) {
      qty = 1;
    }
    return qty;
  }

  cartModalClose.addEventListener("click", function () {
    closeAddModal();
    closeCartOverlay();
  });

  cartDrawerClose.addEventListener("click", function () {
    closeCartDrawer();
    closeCartOverlay();
  });

  cartOverlay.addEventListener("click", function () {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
  });

  cartDrawerTrigger.addEventListener("click", function (event) {
    event.preventDefault();
    fetchCart(true);
    openCartDrawer();
    openCartOverlay();
  });

  document.addEventListener("DOMContentLoaded", function () {
    fetchCart();
  });
  adjustCartHeaderHeight();

  $(".rc_label__deliver_once").click((e) => {
    e.stopImmediatePropagation();
    return false;
  });

  new Swiper(".cart-swiper", {
    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 24,
    observer: true,
    observeParents: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
